<script lang="ts" setup>
import cn from 'internal/tailwind-classmerge'

import { FormItem, type HTMLAttributeClass } from '@fond-of/fondof-ui'

const props = defineProps<HTMLAttributeClass>()
</script>

<template>
  <FormItem :class="cn('w-full', props.class)">
    <slot />
  </FormItem>
</template>
